var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-form',_vm._b({attrs:{"form":_vm.form}},'a-form',_vm.formItemLayout,false),[_c('a-form-item',{attrs:{"label":_vm.$t('scope.text_200')}},[_vm._v(" "+_vm._s(_vm.imobile)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }